module.exports = __webpack_public_path__ + "static/media/arrow-right-outline.b22749de.svg";